import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=7963ca96&scoped=true"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=7963ca96&prod&scoped=true&lang=css"
import style1 from "./ListProjects.vue?vue&type=style&index=1&id=7963ca96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963ca96",
  null
  
)

export default component.exports